export interface TicketEventRefreshPlan {
  refreshStaffMetrics: boolean;
  scheduleStaffQueue: boolean;
  refreshStaffConversation: boolean;
  refreshPlayerConversation: boolean;
}

export function ticketEventRefreshPlan(input: {
  page: string;
  currentStaffTicketId?: string;
  currentPlayerTicketId?: string;
  actionInFlight: boolean;
  interactionActive: boolean;
}): TicketEventRefreshPlan {
  const blocked = input.actionInFlight || input.interactionActive;
  const onCaseDesk = input.page === "cases";
  return {
    refreshStaffMetrics: onCaseDesk && !blocked,
    scheduleStaffQueue: onCaseDesk && !input.currentStaffTicketId,
    refreshStaffConversation: onCaseDesk && Boolean(input.currentStaffTicketId) && !blocked,
    refreshPlayerConversation: input.page === "support" && Boolean(input.currentPlayerTicketId) && !blocked
  };
}
